import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { Card, ProfileCompletionBar } from 'components'
import { useCommunity } from 'utils'
import { buildBarModel } from './survey-completion-sections'

const propTypes = {
  school: Types.school.isRequired,
  participation: Types.participation,
  surveyQuestions: PropTypes.arrayOf(Types.surveyQuestion),
  surveyAttempt: Types.surveyAttempt,
  disciplines: PropTypes.arrayOf(Types.discipline),
}

const defaultProps = {
  participation: null,
  surveyQuestions: null,
  surveyAttempt: null,
  disciplines: null,
}

function SurveyCompletionCard({
  school,
  participation,
  surveyQuestions,
  surveyAttempt,
  disciplines,
}) {
  const community = useCommunity()
  if (!surveyQuestions) return null

  const { sections, completedSections, percent } = buildBarModel({
    school,
    participation,
    surveyQuestions,
    communitySurveyQuestions: community.surveyQuestions,
    surveyAttempt,
    disciplines,
  })

  return (
    <Card className="survey-completion-card">
      <ProfileCompletionBar
        variant="card"
        title="Survey Completion"
        percent={percent}
        completedSections={completedSections}
        sections={sections}
      />
    </Card>
  )
}

SurveyCompletionCard.propTypes = propTypes
SurveyCompletionCard.defaultProps = defaultProps

export default SurveyCompletionCard
